import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 28 28" {...props}>
      <title id="Clock">{props.title || 'Clock'}</title>
      <g>
        <path d="M0 14c0-2.2.5-4.2 1.6-6s2.5-3.3 4.4-4.4 3.8-1.6 6-1.6 4.2.5 6 1.6 3.3 2.5 4.4 4.4 1.6 3.8 1.6 6-.5 4.2-1.6 6c-1.1 1.8-2.5 3.3-4.4 4.4s-3.8 1.6-6 1.6-4.2-.5-6-1.6-3.3-2.5-4.4-4.4-1.6-3.8-1.6-6zm3.5 0c0 1.5.4 3 1.1 4.3s1.8 2.3 3.1 3.1c1.3.8 2.7 1.1 4.3 1.1s3-.4 4.3-1.1 2.3-1.8 3.1-3.1c.8-1.3 1.1-2.7 1.1-4.3s-.4-3-1.1-4.3c-.8-1.3-1.8-2.3-3.1-3.1s-2.8-1.1-4.3-1.1-3 .4-4.3 1.1-2.3 1.8-3.1 3.1-1.1 2.8-1.1 4.3zm4.5 1.5v-1c0-.1 0-.3.1-.4.1-.1.3-.1.4-.1h3.5v-5.5c0-.1 0-.3.1-.4.1-.1.3-.1.4-.1h1c.1 0 .3 0 .4.1.1.1.1.3.1.4v7c0 .1 0 .3-.1.4-.1.1-.3.1-.4.1h-5c-.1 0-.3 0-.4-.1-.1-.1-.1-.3-.1-.4z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/clock.js